/**
 * トラベル検索種類
 */
const TRAVEL_SEARCH_TYPE = {
  STAY: 1,
  DP: 2
};
/**
 * 定数の定義ファイル
 */
export default {
  data() {
    return {
      CONST: {
        /**
         * Navのアイテムの並び順初期値
         */
        NAV_ORDER_DEFAULT: [
          "crly1",
          "crly2",
          "crly3",
          "crly4",
          "crly5",
          "crly6",
          "crly7",
          "crly8",
          "crly9",
          "crly10",
          "crly11"
        ],
        /**
         * 特大カテゴリ一覧
         */
        CATEGORY_TYPE: {
          LIFE: 1,
          GOURMET: 2,
          TRAVEL: 3,
          BENE: 4
        },
        /**
         * （トラベル検索用）中カテゴリ分類一覧
         */
        MIDDLE_CATEGORY_TYPE: TRAVEL_SEARCH_TYPE,
        /**
         * トラベル検索種類
         */
        TRAVEL_SEARCH_TYPE: TRAVEL_SEARCH_TYPE,
        /**
         * 検索遷移のパラメータ
         */
        SEARCH_PARAMS: {
          /**
           * ライフ検索種別
           */
          TYPE: "type",
          /**
           * キーワード
           */
          KEYWORD: "keyword",
          /**
           * 大カテゴリ
           */
          CAT_LRG: "catLrgClassCd",
          /**
           * 中カテゴリ
           */
          CAT_MID: "catMidClassCd",
          /**
           * 小カテゴリ
           */
          CAT_SML: "catSmlClassCd",
          /**
           * エリア
           */
          AREA_LRG: "areaLrgClassCd",
          /**
           * エリア
           */
          AREA_MID: "areaMidClassCd",
          /**
           * エリア
           */
          AREA_SML: "areaSmlClassCd",
          /**
           * ジャンル
           */
          LIFE_GNR: "lifeGenreTags",
          /**
           * ステイ検索種別
           */
          CATEGORY: "category"
        },
        /**
         * メールでのお問い合わせ
         */
        MAIL: {
          /**
           * お問い合わせ内容入力最大文字数
           */
          CONTENT_TEXT_MAX: 1000,
          /**
           * お問い合わせ内容入力初期表示行数
           */
          CONTENT_TEXT_ROWS: 10,
          /**
           * お問い合わせお客様情報 名前最大文字数
           */
          CONTENT_NAME_MAX: 50,
          /**
           * お問い合わせお客様情報 郵便番号最大文字数
           */
          CONTENT_POST_NUMBER_MAX: 7,
          /**
           * お問い合わせお客様情報 住所最大文字数
           */
          CONTENT_ADDRESS_MAX: 50
        },
        /**
         * お気に入り
         */
        FAVORITE: {
          /**
           * お気に入り表示件数 ページ最大表示件数
           */
          PAGE_CONTENT_MAX: 10,
          /**
           * お気に入り取得パラーメータ
           */
          ITEM_TYPE: "favourite"
        }
      },

      /**
       * Navのアイテム定義
       */
      CONST_NAV_ITEM: {
        crly1: {
          name: "レジャー",
          class: "leisure",
          linkName: "CrlyLeisure",
          key: "crly1"
        },
        crly2: {
          name: "グルメ",
          class: "gourmet",
          linkName: "CrlyGourmet",
          key: "crly2"
        },
        crly3: {
          name: "育児",
          class: "childcare",
          linkName: "CrlyChildcare",
          key: "crly3"
        },
        crly4: {
          name: "買い物",
          class: "shopping",
          linkName: "CrlyShopping",
          key: "crly4"
        },
        crly5: {
          name: "リラク",
          class: "relaxation",
          linkName: "CrlyRelaxation",
          key: "crly5"
        },
        crly6: {
          name: "スポーツ",
          class: "sports",
          linkName: "CrlySports",
          key: "crly6"
        },
        crly7: {
          name: "旅行",
          class: "travel",
          linkName: "CrlyTravel",
          key: "crly7"
        },
        crly8: {
          name: "カー",
          class: "car",
          linkName: "CrlyCar",
          key: "crly8"
        },
        crly9: {
          name: "オリジナル",
          class: "original",
          linkName: "CrlyOriginal",
          key: "crly9"
        },
        crly10: {
          name: "学ぶ",
          class: "school",
          linkName: "CrlySchool",
          key: "crly10"
        },
        crly11: {
          name: "ライフ",
          class: "life",
          linkName: "CrlyLife",
          key: "crly11"
        }
      },
      /**
       * BS内リンク先
       */
      CONST_LINK_BS: {
        /**
         * マイページ
         */
        MY_PAGE: `${process.env.VUE_APP_MYPAGE_DOMAIN}/mypage`,
        /**
         * マイクーポン会員証クーポン
         */
        MY_COUPON: `${process.env.VUE_APP_MYPAGE_DOMAIN}/mypage/coupon/member?sort=getCouponDatetime`,
        /**
         * 利用履歴
         */
        HISTORY: `${process.env.VUE_APP_MYPAGE_DOMAIN}/mypage/orders`,
        /**
         * ベネポ
         */
        BENEPO: `${process.env.VUE_APP_MYPAGE_DOMAIN}/mypage/benepo`,
        /**
         * 個人設定
         */
        SETTING: `${process.env.VUE_APP_MYPAGE_DOMAIN}/mypage/setting`,
        /**
         * 個人情報保護方針
         */
        PRIVACY_POLICY:
          "https://bs.st.benefit-one.inc/otherPage?other_id=privacy",
        /**
         * 個人情報の取り扱い
         */
        PRIVACY_POLICY_HANDLING:
          "https://bs.st.benefit-one.inc/otherPage?other_id=handling"
      },
      CONST_LINK: {
        /**
         * 子育て応援支援
         */
        KOSODATE_OUEN:
          "https://www.softbank.jp/mobile/service/softbankpremium/kosodate-ouen-club/",
        /**
         * とく放題M加入状況
         */
        TOKUHODAI_M: "https://my.softbank.jp/msb/d/webLink/doSend/WBC010010",
        /**
         * とく放題B加入状況
         */
        TOKUHODAI_B: "https://m.bbss.softbankbb.co.jp/MOB/myPage/?page=option"
      },
      AGREE_FLG: {
        YES: "1",
        NO: "0"
      },
      /**
       * 人気ランキングマークなど
       */
      MARK: {
        RANKING: 12,
        DOUBLE_DIGIT: 10
      }
    };
  }
};
